import React from 'react'

const Title = ({heading}) => {
    return (
        <div>            
            <h2>{heading}</h2>
        </div>
    )
}

export default Title
